module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.10-242.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.10.md
// module id = 684
// module chunks = 286